import { NavbarLinks } from '@/constants/navbar';
import { ArrowUpRight, PhoneCallIcon, TextAlignEnd } from 'lucide-react';
import { useState } from 'react';
import { NavbarMobileViewSidebar } from './navbar/NavbarMobileView';
import { useNavigate } from 'react-router-dom';

export const Navbar = () => {
  let navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="fixed top-0 z-[5555] flex w-full flex-row flex-wrap items-center justify-center bg-white px-[2rem] font-inter text-[#121212]">
      <div className="hidden w-full max-w-[144rem] flex-row flex-wrap items-center justify-between lg:flex lg:h-[11.11rem]">
        <div className="flex flex-wrap items-center justify-start gap-[0.5rem]">
          <img alt="ico" className="h-[5rem] w-[5rem]" src="/favicon.png" />
          <h1 className="mt-[-0.1rem] text-[2.2rem] font-[800] leading-[100%] text-[#ff8c00]">
            Contractors
            <br />
            <span className="text-[#0273c9]">Limited</span>
          </h1>
        </div>
        <div className="mt-[3rem] flex flex-row flex-wrap items-stretch justify-start gap-[5rem] text-[1.6rem]">
          {NavbarLinks.map((item, index) => (
            <div key={index} className="hover group">
              {' '}
              <p
                onClick={() => {
                  navigate(item.link);
                }}
                key={item}
                className="cursor-pointer text-[1.6rem] font-[500] transition-colors duration-300 hover:text-[#e24e1f]"
              >
                {item.label}
              </p>
              {item.sublinks && (
                <>
                  <div className="pt-[4rem]">
                    <div
                      style={{ boxShadow: '0px 10px 60px 0px rgba(0, 0, 0, 0.09)' }}
                      className="sublink flex-cols absolute z-[0] hidden max-h-[70vh] w-[30rem] gap-[1rem] overflow-y-auto border-[#eee] bg-white group-hover:block"
                    >
                      {item.sublinks &&
                        item?.sublinks?.map((item2, index2) => (
                          <p
                            onClick={() => {
                              if (item2.link) navigate(item2.link);
                            }}
                            key={index2}
                            className={`cursor-pointer ${item.sublinks.length !== index2 + 1 && 'border-b'} border-[#D3D8E2] px-[1.5rem] py-[1.5rem] text-[1.5rem] font-[500] transition-colors duration-300 hover:text-[#e24e1f]`}
                          >
                            {item2.label}
                          </p>
                        ))}
                    </div>
                  </div>{' '}
                </>
              )}
            </div>
          ))}
        </div>
        <div className="jusitfy-start z-[5555] flex flex-row flex-wrap gap-[4rem]">
          <div className="flex-row flex-wrap justify-start gap-[1rem] lg:hidden xl:flex">
            <div className="flex h-[5rem] w-[5rem] items-center justify-center rounded-full bg-orange-500">
              <PhoneCallIcon className="text-[2.4rem] text-white" />
            </div>
            <div className="flex flex-col gap-[0.2rem] text-[1.6rem] text-[#666666]">
              <p className="font-[400]">Call Us Any time:</p>
              <p className="text-[2rem] font-[600]">07454-926-222</p>
            </div>
          </div>
          <div
            onClick={() => {
              navigate('/contact-us');
            }}
            className="flex h-[4.3rem] w-[16.2rem] cursor-pointer flex-row flex-wrap items-center justify-center gap-[1rem] border-[2px] border-orange-500 text-[1.6rem] font-[700] hover:text-[#e24e1f]"
          >
            <p>Get A Quote</p>
            <ArrowUpRight />
          </div>
        </div>
      </div>
      <div className="flex h-[9rem] w-full max-w-[144rem] flex-row flex-wrap items-center justify-between lg:hidden lg:h-[11.11rem]">
        <div className="flex flex-wrap items-center justify-start gap-[0.5rem]">
          <img alt="ico" className="h-[4.5rem] w-[4.5rem]" src="/favicon.png" />
          <h1 className="mt-[-0.1rem] text-[2rem] font-[800] leading-[100%] text-[#ff8c00]">
            Contractors
            <br />
            <span className="text-[#0273c9]">Limited</span>
          </h1>
        </div>
        <div
          onClick={() => setIsOpen(true)}
          className="jusitfy-start flex flex-row flex-wrap gap-[4rem]"
        >
          <TextAlignEnd className="h-auto w-[3.5rem] text-[#ff8c00]" />
        </div>
      </div>
      <NavbarMobileViewSidebar isOpen={isOpen} setIsOpen={setIsOpen} />
    </div>
  );
};
